var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServiceCs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8504 30.9593L22.2916 13.8058C23.0708 12.5257 24.9292 12.5257 25.7084 13.8058L36.1497 30.9593C36.9609 32.2921 36.0015 33.9992 34.4413 33.9992H13.5588C11.9985 33.9992 11.0391 32.2921 11.8504 30.9593ZM24.9998 26.9992V19.9992C24.9998 19.4469 24.5521 18.9992 23.9998 18.9992C23.4475 18.9992 22.9998 19.4469 22.9998 19.9992V26.9992C22.9998 27.5514 23.4475 27.9992 23.9998 27.9992C24.5521 27.9992 24.9998 27.5514 24.9998 26.9992ZM23.9998 30.9991C23.4475 30.9991 22.9998 30.5514 22.9998 29.9991C22.9998 29.4469 23.4475 28.9991 23.9998 28.9991C24.5521 28.9991 24.9998 29.4469 24.9998 29.9991C24.9998 30.5514 24.5521 30.9991 23.9998 30.9991Z",
    fill: "#363A4D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceCs);
export default __webpack_public_path__ + "static/media/service_cs.2ca166b3095ad48543903ab79c62a44c.svg";
export { ForwardRef as ReactComponent };